import { render } from "./UserBadgeDisplay.vue?vue&type=template&id=746a2c39&scoped=true&ts=true"
import script from "./UserBadgeDisplay.vue?vue&type=script&lang=ts"
export * from "./UserBadgeDisplay.vue?vue&type=script&lang=ts"

import "./UserBadgeDisplay.vue?vue&type=style&index=0&id=746a2c39&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746a2c39"]])

export default __exports__